function openUrl(url, openInNewWindow = true) {
    if (openInNewWindow) {
        window.open(url, '_blank').focus();
    } else {
        window.location.href = url;
    }
}

export { openUrl }